import {AnnouncementSlides} from "./AnnouncementSlides";
import {Display} from "./Display";
import {NewsSlides} from "./NewsSlides";
import {Observer} from "./Observer";
import {Video} from "./Video";
import {WorkSlides} from "./WorkSlides";
import {Lightbox} from "./Lightbox";
import {Search} from "./Search";

// noinspection JSUnresolvedVariable,JSUnresolvedFunction
export class Basic
{
    static init()
    {
        Basic.base = '/';
        Basic.lang = 'de';
        Basic.resizeTimer = 0;
    }

    static add_changeEvent()
    {
        document.body.addEventListener('change',e =>
        {
            let el = e.target;

            if(el.classList.contains('mod--select'))
            {
                el.closest('form').submit();
            }
        });
    }

    static add_submitEvent()
    {
        document.body.addEventListener('submit',e =>
        {
            let el = e.target;

            if(el.dataset.f === 'search')
            {
                e.preventDefault();
                if(window.search)
                {
                    window.search.get_result();
                }
            }
        });
    }

    static add_clickEvent()
    {
        document.body.addEventListener('click',e =>
        {
            let el = e.target;

            if(el.classList.contains('ise') || el.closest('.ise'))
            {
                return false;
            }
            else if(el.closest('.w__js-button'))
            {
                el = el.closest('.w__js-button');
            }

            if(el.classList.contains('w__js-button') &&
               el.dataset.f)
            {
                e.preventDefault();

                switch(el.dataset.f)
                {
                    case 'announcement-switch':
                        AnnouncementSlides.switch(el);
                        break;


                    case 'do-fulltext-search':
                        if(window.search)
                        {
                            window.search.get_result()
                        }
                        break;

                    case 'fulltext-search':
                        window.search = new Search();
                        break;

                    case 'overlay-close':
                        Basic.close_overlay(el.dataset.target);
                        break;

                    case 'news-slide-switch':
                        NewsSlides.switch(el);
                        break;

                    case 'switch-language':
                        const parent = el.closest('.w__text--container');
                        if(parent)
                        {
                            parent.querySelector('.w__text--version.active').classList.remove('active');
                            parent.querySelector('.w__button.active').classList.remove('active');
                            el.classList.add('active');
                            document.getElementById('w--' + el.dataset.code).classList.add('active');
                        }
                        break;

                    case 'toggle-filter':
                        if(document.body.classList.contains('mod--filter-active'))
                        {
                            document.body.classList.remove('mod--filter-active');
                            localStorage.removeItem(document.location.pathname);
                        }
                        else
                        {
                            document.body.classList.add('mod--filter-active');
                            localStorage.setItem(document.location.pathname, '1');
                        }
                        break;

                    case 'toggle-menu':
                        const main = document.body.querySelector('.w__main');

                        if(document.body.classList.contains('mod--mobile-menu'))
                        {
                            document.body.classList.remove('mod--mobile-menu');
                            if(main)
                            {
                                main.style.transform = '';
                                document.documentElement.scrollTo(0, parseInt(sessionStorage.getItem('scrollY')));
                                sessionStorage.removeItem('scrollY');
                            }
                        }
                        else
                        {
                            if(main)
                            {
                                sessionStorage.setItem('scrollY', window.scrollY.toString());
                                main.style.transform = 'translateY(' + (window.scrollY * -1).toString() + 'px)';
                            }
                            document.body.classList.add('mod--mobile-menu');
                        }
                        break;

                    case 'video':
                        new Video(el);
                        break;

                    case 'work-slide-switch':
                        WorkSlides.switch(el,0);
                        break;

                    default:
                        console.log('Missing case: ' + el.dataset.f);
                }
            }
            else if(Display.device === 'desktop' &&
                    el.classList.contains('w__text--image'))
            {
                new Lightbox(el);
            }
        });
    }

    static adjust_imagePath(imgSrc, sizeX, srcX)
    {
        sizeX *= Display.dpi;

        let sizeY,
            srcPath = '',
            targetPath = '';

        if(imgSrc.match(/\/bg\//))
        {
            sizeX = Display.dpi * Display.x;
            sizeY = Display.dpi * (Display.y - 40);

            // use y size
            if(sizeX/sizeY < 3/2)
            {
                if(sizeY <= 400)
                {
                    targetPath = '600x400';
                }
                else if(sizeY <= 700)
                {
                    targetPath = '1050x700';
                }
                else if(sizeY <= 1000)
                {
                    targetPath = '1500x1000';
                }
                else if(sizeY <= 1280)
                {
                    targetPath = '1920x1280';
                }
                else
                {
                    targetPath = '2550x1700';
                }
            }

            // use x size
            else
            {
                if(sizeX <= 600)
                {
                    targetPath = '600x400';
                }
                else if(sizeX <= 1050)
                {
                    targetPath = '1050x700';
                }
                else if(sizeX <= 1500)
                {
                    targetPath = '1500x1000';
                }
                else if(sizeX <= 1920)
                {
                    targetPath = '1920x1280';
                }
                else
                {
                    targetPath = '2550x1700';
                }
            }

            targetPath = '/bg/' + targetPath + "/";
            srcPath = '/bg/1920x1280/';
        }
        else if(imgSrc.match(/\/std\//))
        {
            sizeX *= Display.dpi;

            if(sizeX <= srcX * .5)
            {
                targetPath = 'p50';
            }
            else if(sizeX <= srcX * .75)
            {
                targetPath = 'p75';
            }
            else
            {
                targetPath = 'p100';
            }

            targetPath = '/std/' + targetPath + "/";
            srcPath = '/std/p100/';
        }

        return imgSrc.replace(srcPath, targetPath);
    }

    static build_overlay(type)
    {
        const div = document.createElement('div');
        div.classList.add('w__overlay');
        div.classList.add('mod--' + type);
        div.id = 'w--' + type;

        const closeButton = document.createElement('button');
        closeButton.classList.add('w__button');
        closeButton.classList.add('w__overlay--close');
        closeButton.classList.add('w__js-button');
        closeButton.dataset.f = 'overlay-close';
        closeButton.dataset.target = type;
        closeButton.alt = 'Close ' + type;

        div.appendChild(closeButton);

        // append lightbox to body
        document.body.appendChild(div);

        // store scroll position
        const main = document.body.querySelector('.w__main');

        if(main)
        {
            sessionStorage.setItem('scrollY', window.scrollY.toString());
            main.style.transform = 'translateY(' + (window.scrollY * -1).toString() + 'px)';
            document.body.classList.add('mod--lightbox-active');
        }

        return div;
    }

    static close_overlay(type)
    {
        const lightbox = document.getElementById('w--' + type);
        if(lightbox)
        {
            lightbox.remove();
            if(window.search)
            {
                delete window.search;
            }

            const main = document.body.querySelector('.w__main');

            if(main)
            {
                main.style.transform = '';
            }

            document.body.classList.remove('mod--lightbox-active');
            document.documentElement.scrollTo(0, parseInt(sessionStorage.getItem('scrollY')));
            sessionStorage.removeItem('scrollY');
        }
    }

    static do_afterLoad()
    {
        // open filters
        if(localStorage.getItem(document.location.pathname) === '1')
        {
            document.body.classList.add('mod--filter-active');
        }

        // find announcement slides
        const announcementSlides = document.body.querySelectorAll('.w__bg--slide');
        if(announcementSlides.length > 1)
        {
            new AnnouncementSlides(announcementSlides);
        }

        // find news slides
        const newsSlides = document.body.querySelectorAll('.w__module--media.mod--news:not(.mod--processed)');
        if(newsSlides.length)
        {
            new NewsSlides(newsSlides);
        }

        // find work slides
        const workSliders = document.body.querySelectorAll('.w__module--media.mod--work:not(.mod--processed)');
        if(workSliders.length)
        {
            new WorkSlides(workSliders);
        }

        // intersection observer
        if(document.getElementById('w--load-into') &&
           document.getElementById('w--load-into').dataset.autoload)
        {
            new Observer(document.getElementById('w--load-into'));
        }
    }

    static insert_switchControls(container, f)
    {
        const controlsContainer = document.createElement('div');
        controlsContainer.classList.add('w__controls-container');

        const controls = document.createElement('div');
        controls.classList.add('w__controls');

        const prev = document.createElement('button');
        prev.classList.add('w__button');
        prev.classList.add('w__js-button');
        prev.dataset.f = f;

        const next = prev.cloneNode(true);
        prev.classList.add('mod--prev');
        prev.title = 'Previous';
        next.classList.add('mod--next');
        next.title = 'Next';

        controlsContainer.appendChild(controls);
        controls.appendChild(prev);
        controls.appendChild(next);
        container.appendChild(controlsContainer);
    }

    static process_resize()
    {
        Display.analyze();
    }
}

